import { Middleware } from '@nuxt/types';

const homeMiddleware: Middleware = async ({ store }) => {
  console.info('[homeMiddleware]');

  await store.dispatch('explorer/getDestinations', { lang: store.state.lang.locale });
};

export default homeMiddleware;
